import classnames from "classnames";
import * as I from "immutable";
import ImmutablePropTypes from "react-immutable-proptypes";
import Raven from "raven-js";
import React, {Component} from "react";
import PropTypes from "prop-types";

import {trackEvent} from "metrics";

import api from "v2/api";
import {Route} from "v2/api/Records";

import RouteSelect from "v2/components/RouteSelect";

import ModalForm from "v2/components/responsive/ModalForm";

export default class ReassignRestForm extends Component {
  static contextTypes = {
    dateData: ImmutablePropTypes.listOf(Route),
    location: PropTypes.object,
    onUpdateDateData: PropTypes.func,
    onUpdateRouteData: PropTypes.func,
    params: PropTypes.shape({
      date: PropTypes.string.isRequired,
      routeId: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
    }),
    router: PropTypes.object,
  }

  static propTypes = {
    modal: PropTypes.bool,
    onCancel: PropTypes.func,
  }

  constructor(props, context) {
    super(props, context);

    this.state = {
      selectedRoute: null,
      errors: I.Map(),
    };
  }

  handleSelectChange = (item) => {
    this.setState({
      selectedRoute: item && item.value,
    });
  }

  handleSubmit = (evt) => {
    evt.preventDefault();
    this.setState({
      submitted: true,
    });

    const {
      location: {query},
      onUpdateDateData,
      onUpdateRouteData,
      params: {date, routeId, id},
      router,
    } = this.context;
    const {modal, onCancel} = this.props;
    const {selectedRoute} = this.state;

    api()
      .post(this.apiUrl, {
        "last_destination": id,
        "new_route": selectedRoute,
      })
      .then(() => {
        onUpdateRouteData(null, () => {
          if (modal) {
            onCancel();
          } else {
            router.push({
              pathname: `/${date}/${routeId}`,
              query,
            });
          }
          trackEvent("Reassign rest", ["Route", "reassign rest", routeId], {
            Date: date,
            ID: routeId,
          });
          onUpdateDateData();
        });
      })
      .catch((err) => {
        if (err.response && err.response.status === 400) {
          this.setState({
            errors: I.Map(err.response.data),
            submitted: false,
          });
        } else {
          this.setState({
            errors: I.Map({
              message: "Server Error. Please contact engineering team if error will repeat after page reload.",
            }),
            submitted: false,
          });
          Raven.captureException(err);
        }
      });
  }

  get apiUrl() {
    const {params: {routeId}} = this.context;
    return `/routes/${routeId}/reassign-rest`;
  }

  renderContent() {
    const {selectedRoute, errors} = this.state;

    let serverError;
    if (errors.get("message")) {
      serverError = (
        <div className={classnames("text-danger")}>
          {errors.get("message")}
        </div>
      );
    }

    return (
      <div className="form-horizontal">
        <RouteSelect
          error={errors.get("newRoute")}
          fieldContainerClassName="col-xs-12 col-sm-9"
          focus
          labelClassName="col-xs-12 col-sm-3 control-label"
          onChange={this.handleSelectChange}
          selected={selectedRoute} />

        {serverError}
      </div>
    );
  }

  render() {
    const {submitted} = this.state;
    return (
      <ModalForm
        btnSubmitDisabled={submitted}
        btnSubmitLabel="Reassign"
        modalTitle="Reassign Rest of the Route"
        onSubmit={this.handleSubmit}
        pageTitle="Reassign Rest of the Route"
        {...this.props}>
        {this.renderContent()}
      </ModalForm>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/responsive/ReassignRestForm.js
 **/